import React, { useState, useEffect } from "react";
import { FaTimes, FaUser, FaEnvelope, FaPhoneAlt, FaMapMarkerAlt } from "react-icons/fa";
import { toast } from "react-toastify";

export const SecondaryUserDrawer = ({
  isOpen,
  onClose,
  userData,
  token,
  onUpdate,
  onSendOTP,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    address: {
      street: "",
      landmark: "",
      city: "",
      state: "",
      pincode: "",
    },
  });
  const [newPhone, setNewPhone] = useState("");
  const [otp, setOtp] = useState("");
  const [showOtpField, setShowOtpField] = useState(false);
  const [loading, setLoading] = useState(false);
  const [originalPhone, setOriginalPhone] = useState("");

  // Prefill form when drawer opens
  useEffect(() => {
    if (isOpen && userData) {
    
      setFormData({
        name: userData.name || "",
        email: userData.email || "",
        phone: userData.phone || "",
        address: {
          street: userData.address?.street || "",
          landmark: userData.address?.landmark || "",
          city: userData.address?.city || "",
          state: userData.address?.state || "",
          pincode: userData.address?.pincode || "",
        },
      });
      setNewPhone(userData.phone || "");
      setOriginalPhone(userData.phone || "");
      setOtp("");
      setShowOtpField(false);
    }
  }, [isOpen, userData]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name.startsWith("address.")) {
      const key = name.split(".")[1];
      setFormData((prev) => ({
        ...prev,
        address: { ...prev.address, [key]: value },
      }));
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, "").slice(0, 10);
    setNewPhone(value);
    if (value === originalPhone) {
      setShowOtpField(false);
      setOtp("");
    }
  };

  const handleSendOTP = async () => {
    if (!newPhone || newPhone.length !== 10) {
      toast.error("Please enter a valid 10-digit phone number");
      return;
    }

    if (newPhone === originalPhone) {
      toast.info("Phone number unchanged. No OTP needed.");
      return;
    }

    const success = await onSendOTP(userData?._id, newPhone);
    if (success) {
      setShowOtpField(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
   // if (!formData.name.trim()) {
     // toast.error("Name is required");
    //  return;
   // }
    
   // if (!formData.email.trim()) {
     // toast.error("Email is required");
     // return;
   // }
    
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
     if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) {
      toast.error("Please enter a valid email address");
       return;
    }
      
    // Check if phone number changed
    const isPhoneChanged = newPhone !== originalPhone;
    
    if (isPhoneChanged && !otp) {
      toast.error("Please enter OTP to verify new phone number");
      return;
    }
    setLoading(true);
     console.log("Calling onUpdate with ID:", userData?._id); 
    const success = await onUpdate(userData?._id, formData, isPhoneChanged ? newPhone : null, otp);
    setLoading(false);
    
    if (success) {
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 bg-black/50 z-[1000]" onClick={onClose} />

      {/* Drawer */}
      <div className="fixed inset-y-0 right-0 w-full max-w-md bg-white shadow-2xl flex flex-col transform transition-transform duration-300 z-[1000] translate-x-0">
        {/* Header */}
        <div className="flex justify-between items-center px-5 py-4 border-b bg-orange-50">
          <h2 className="text-lg font-semibold text-gray-800">Edit Secondary User</h2>
          <button onClick={onClose} className="text-gray-600 hover:text-gray-800">
            <FaTimes size={22} />
          </button>
        </div>

        {/* Form Content */}
        <form onSubmit={handleSubmit} className="flex-1 overflow-y-auto p-5 space-y-6">
          {/* Basic Information */}
          <div>
            <h3 className="text-base font-semibold text-gray-800 mb-4">Basic Information</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Full Name 
                    
                </label>
                <div className="relative">
                  <FaUser className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    name="name"
                    value={formData.name}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Enter full name"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Email Address 
                </label>
                <div className="relative">
                  <FaEnvelope className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="Enter email address"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Phone Number
                    <span className="text-red-500">*</span>
                </label>
                <div className="relative">
                  <FaPhoneAlt className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="tel"
                    value={newPhone}
                    onChange={handlePhoneChange}
                    placeholder="Enter 10-digit mobile number"
                    maxLength="10"
                    className="w-full pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
                {newPhone !== originalPhone && (
                    <div className="mt-3">
                        <button
                        type="button"
                        onClick={handleSendOTP}
                        className="w-full flex items-center justify-center gap-2 px-4 py-2.5 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold rounded-lg shadow-sm transition"
                        >
                        Send OTP
                        </button>

                        <p className="text-xs text-gray-500 mt-1 text-center">
                        Required to verify new phone number
                        </p>
                    </div>
                    )}
                <p className="text-sm font-semibold text-gray-800 mt-1">OTP required only if phone number is changed</p>
              </div>

              {/* OTP Field */}
              {showOtpField && (
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">OTP 
                    <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    value={otp}
                    onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 4))}
                    placeholder="Enter 4-digit OTP"
                    maxLength="4"
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  />
                </div>
              )}
            </div>
          </div>

          {/* Address Information */}
          <div>
            <h3 className="text-base font-semibold text-gray-800 mb-4">Address Information</h3>
            <div className="space-y-4">
              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Street / House No.</label>
                <input
                  type="text"
                  name="address.street"
                  value={formData.address.street}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="Street address"
                />
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Landmark (Optional)</label>
                <input
                  type="text"
                  name="address.landmark"
                  value={formData.address.landmark}
                  onChange={handleChange}
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                  placeholder="Nearby landmark"
                />
              </div>

              <div className="grid grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">City</label>
                  <input
                    type="text"
                    name="address.city"
                    value={formData.address.city}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="City"
                  />
                </div>
                <div>
                  <label className="block text-sm font-semibold text-gray-800 mb-1">State</label>
                  <input
                    type="text"
                    name="address.state"
                    value={formData.address.state}
                    onChange={handleChange}
                    className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                    placeholder="State"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-semibold text-gray-800 mb-1">Pincode</label>
                <input
                  type="text"
                  name="address.pincode"
                  value={formData.address.pincode}
                  onChange={handleChange}
                  placeholder="Postal code"
                  maxLength="6"
                  className="w-full px-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500"
                />
              </div>
            </div>
          </div>
        </form>

        {/* Footer Button */}
        <div className="p-5 border-t bg-gray-50">
          <button
            type="submit"
            onClick={handleSubmit}
            disabled={loading}
            className="w-full bg-orange-500 hover:bg-orange-600 text-white py-3 rounded-lg font-medium transition-all disabled:opacity-50"
          >
            {loading ? "Updating..." : "Save Changes"}
          </button>
        </div>
      </div>
    </>
  );
};